module.exports = __webpack_public_path__ + "img/a5.46824dbc.png";